import {
    CREATE_MENU_MASTER_FAILURE,
    CREATE_MENU_MASTER_REQUEST,
    CREATE_MENU_MASTER_SUCCESS,
    CREATE_USER_FORM_MENU_MASTER,
    FETCH_MENU_MASTER_FAILURE,
    FETCH_MENU_MASTER_REQUEST,
    FETCH_MENU_MASTER_SUCCESS,
    FETCH_SINGLE_MENU_MASTER_FAILURE,
    FETCH_SINGLE_MENU_MASTER_REQUEST,
    FETCH_SINGLE_MENU_MASTER_SUCCESS,
    MENU_MASTER_USERFORM_RESET,
    MENU_PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_FAILURE,
    MENU_PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_REQUEST,
    MENU_PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_SUCCESS,
    MENU_PROPERTY_TVNAME_FOR_DROPDOWN_FAILURE,
    MENU_PROPERTY_TVNAME_FOR_DROPDOWN_REQUEST,
    MENU_PROPERTY_TVNAME_FOR_DROPDOWN_SUCCESS,
    UPDATE_MENU_MASTER_REQUEST,
    UPDATE_MENU_MASTER_SUCCESS,
    UPDATE_MENU_MASTER_FAILURE,
    DELETE_MENU_MASTER_REQUEST,
    DELETE_MENU_MASTER_SUCCESS,
    DELETE_MENU_MASTER_FAILURE,
    FETCH_MENU_FILTER_REQUEST,
    FETCH_MENU_FILTERED_REQUEST,
    FETCH_MENU_FILTER_FAILURE,
    FETCH_MENU_FILTERED_FAILURE,
    FETCH_MENU_FILTER_SUCCESS,
    FETCH_MENU_FILTERED_SUCCESS
} from './menuMaster.actionsType';

export const MENU_MASTER = 'menuMaster';

let initialState = {
    loading: false,
    menuMaster: [],
    userform: {},
    propertyList: {},
    TVNameList: {},
    selectedMenu: {},
    errorMessage: '',
    iperrorMessage: '',
    userRolesLists: [],
    filteredMenuList: []
};

export let menuMasterReducer = (state = initialState, action) => {
    let { type, payload, updatePayload } = action;

    switch (type) {
        case FETCH_MENU_MASTER_REQUEST:
        case MENU_PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_REQUEST:
        case MENU_PROPERTY_TVNAME_FOR_DROPDOWN_REQUEST:
        case CREATE_MENU_MASTER_REQUEST:
        case FETCH_SINGLE_MENU_MASTER_REQUEST:
        case UPDATE_MENU_MASTER_REQUEST:
        case DELETE_MENU_MASTER_REQUEST:
        case FETCH_MENU_FILTER_REQUEST:
        case FETCH_MENU_FILTERED_REQUEST:
            return {
                ...state,
                loading: true
            };
        case FETCH_MENU_FILTERED_SUCCESS:
            return {
                ...state,
                filteredMenuList: updatePayload
            }
        case FETCH_MENU_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                menuMaster: payload.USR
            };
        case MENU_PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_SUCCESS:
            return {
                ...state,
                loading: false,
                propertyList: payload
            };
        case MENU_PROPERTY_TVNAME_FOR_DROPDOWN_SUCCESS:
            return {
                ...state,
                loading: false,
                TVNameList: payload
            };

        case CREATE_MENU_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {}
            };
        case FETCH_SINGLE_MENU_MASTER_SUCCESS:
            return {
                ...state,
                selectedMenu: payload,
                loading: false,
                userform: {
                    menu: payload.fldTableOrView,
                    category: payload.fldFKCategory,
                    menuName: payload.fldMenuName,
                    TVName: payload.fldTableOrViewName,
                    condition: payload.fldCondition,
                    roleMenu: payload.fldRoleOfTheMenu,
                    fldControllerName: payload.fldControllerName,
                    fldIcon: payload.fldIcon
                }
            };
        case UPDATE_MENU_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {},
                selectedMenu: {},
                propertyList: {},
                TVNameList: {}
            };
        case DELETE_MENU_MASTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userform: {},
                propertyList: {},
                TVNameList: {},
                selectedMenu: {}
            };
        case FETCH_MENU_MASTER_FAILURE:
        case MENU_PROPERTY_FROM_PROPERTY_TABLE_FOR_DROPDOWN_FAILURE:
        case MENU_PROPERTY_TVNAME_FOR_DROPDOWN_FAILURE:
        case CREATE_MENU_MASTER_FAILURE:
        case FETCH_SINGLE_MENU_MASTER_FAILURE:
        case UPDATE_MENU_MASTER_FAILURE:
        case DELETE_MENU_MASTER_FAILURE:
        case FETCH_MENU_FILTER_FAILURE:
        case FETCH_MENU_FILTERED_FAILURE:
            return {
                ...state,
                loading: false,
                errorMessage: payload
            };
        case CREATE_USER_FORM_MENU_MASTER:
            return {
                ...state,
                userform: {
                    ...state.userform,
                    [payload.key]: payload.value
                }
            };
        case FETCH_MENU_FILTER_SUCCESS:
            return {
                ...state,
                loading: false,
                userRolesLists: updatePayload
            }
        case MENU_MASTER_USERFORM_RESET:
            return {
                ...state,
                userform: {},
                propertyList: {},
                TVNameList: {},
                selectedMenu: {}
            };
        default:
            return state;
    }
};
